import { CATFISHING_ROMANCE_QUESTIONS } from './data/catfishingRomanceQuestions';
import { PIG_BUTCHERING_CRYPTO_QUESTIONS } from './data/pigButcheringCryptoQuestions';

// The two MoSAIC PSYOPS behavioral screenings. Both share one assessment page
// and one results page; only the title, hero and question bank differ.
export const ASSESSMENTS = {
  'catfishing-romance': {
    slug: 'catfishing-romance',
    title: 'Catfishing / Romance',
    heroImage: '/images/mosaic-psyops/catfishing-romance-hero.jpeg',
    questions: CATFISHING_ROMANCE_QUESTIONS,
  },
  'pig-butchering-crypto': {
    slug: 'pig-butchering-crypto',
    title: 'Pig Butchering / Crypto',
    heroImage: '/images/mosaic-psyops/pig-butchering-crypto-hero.jpeg',
    questions: PIG_BUTCHERING_CRYPTO_QUESTIONS,
  },
};

export const assessmentPath = (slug) => `/dashboard/${slug}`;
export const resultsPath = (slug) => `/dashboard/${slug}/results`;
